import { connect } from "react-redux";
import { showAlert } from "rivals/redux/alert/actions";
import { getBillingInformationConstants } from "rivals/redux/rails/selectors";
import { State } from "rivals/redux/reducer";
import { payOutstandingBalance } from "rivals/redux/subscription/actions";
import {
  updateBillingInformation,
  updatePayPalAddress,
  updatePayPalAuthorizationData
} from "rivals/redux/user/actions";
import {
  getAddress,
  getBillingInformation,
  getCurrentUserEmail,
  getCurrentUserPaypalEmail,
  getPayPalAddress,
  getPayPalEmail,
  getPayPalToken,
  getSubmitting,
  selectUserMessage
} from "rivals/redux/user/selectors";
import { StateProps } from "./types";
import BillingInformation from ".";

const mapStateToProps = (state: State): StateProps => ({
  address: getAddress(state),
  billingInformation: getBillingInformation(state),
  message: selectUserMessage(state),
  payPalAddress: getPayPalAddress(state),
  payPalEmail: getPayPalEmail(state),
  payPalToken: getPayPalToken(state),
  railsConstants: getBillingInformationConstants(state),
  submitting: getSubmitting(state),
  userEmail: getCurrentUserEmail(state),
  userPayPalEmail: getCurrentUserPaypalEmail(state)
});

const mapDispatchToProps = {
  payOutstandingBalance,
  showAlert,
  updateBillingInformation,
  updatePayPalAddress,
  updatePayPalAuthorizationData
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingInformation);
